import React from 'react';
import { useTranslation } from 'react-i18next';
import '../styles/ElDesguace.css';

const ElDesguace = () => {
    const { t } = useTranslation();

    return (
        <div className="el-desguace-container">
            <div className="el-desguace-header">
                <h1>{t('eldesguace.title')}</h1>
                <p className="subtitle">{t('eldesguace.subtitle')}</p>
            </div>
            
            <div className="el-desguace-content">
                <div className="main-content">
                    <div className="twitch-widget-container">
                        <iframe
                            src="https://player.twitch.tv/?channel=eldesguace_sc&parent=www.corvusnocta.org"
                            frameBorder="0"
                            allowFullScreen={true}
                            scrolling="no"
                            height="378"
                            width="620"
                            title="El Desguace Twitch Stream"
                        ></iframe>
                    </div>
                    
                    <div className="donation-links">
                        <div className="donation-link auec">
                            <div className="donation-text">
                                <span>{t('eldesguace.donate.auec')}</span>
                                <span className="recipient">{t('eldesguace.donate.recipient')}</span>
                            </div>
                        </div>
                        <a href="https://streamlabs.com/eldesguace_sc/tip" target="_blank" rel="noopener noreferrer" className="donation-link streamlabs">
                            <i className="fas fa-heart"></i>
                            <span>{t('eldesguace.donate.streamlabs')}</span>
                        </a>
                    </div>
                    
                    <div className="podcast-banners">
                        <a href="https://open.spotify.com/show/60sYmyXxVKofj4CgpE70aq?si=292353cf88e14cab" target="_blank" rel="noopener noreferrer" className="podcast-banner">
                            <i className="fab fa-spotify"></i>
                            <span>{t('eldesguace.platforms.spotify')}</span>
                        </a>
                        <a href="https://www.ivoox.com/s_p2_1356522_1.html" target="_blank" rel="noopener noreferrer" className="podcast-banner">
                            <i className="fas fa-podcast"></i>
                            <span>{t('eldesguace.platforms.ivoox')}</span>
                        </a>
                        <a href="https://podcasts.apple.com/us/podcast/el-desguace-un-podcast-de-star-citizen-en-espa%C3%B1ol/id1586570461" target="_blank" rel="noopener noreferrer" className="podcast-banner">
                            <i className="fab fa-apple"></i>
                            <span>{t('eldesguace.platforms.apple')}</span>
                        </a>
                        <a href="https://podcasts.google.com/feed/aHR0cHM6Ly9hbmNob3IuZm0vcy82YjRlZWFiMC9wb2RjYXN0L3Jzcw" target="_blank" rel="noopener noreferrer" className="podcast-banner">
                            <i className="fab fa-google"></i>
                            <span>{t('eldesguace.platforms.google')}</span>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ElDesguace; 